<div *ngIf="_edm.editing" class="inline" style="margin-top: 12px;">
    <span class="display-block bold" style="color: #0068b1; margin-left: 4px;">{{_pageTitleConstituent}}</span>
    <span class="display-block bold" style="margin-left: 4px;">{{_pageTitleComposition}}</span>
</div>

<div>
    <span class="bold page-subtitle" style="margin-left: 2px; margin-top: 4px;">{{_validationMessage}}</span>
</div>
<div style="margin-top: 12px; margin-left: -8px;">
    <editor-header [edm]="_edm" [customButtons]="true">
        <span customButtons class="inline" style="margin-left: 10px; margin-top: 6px;">
            <button *ngIf="showSaveButton()" type="button" class="btn btn-sm btn-primary" [disabled]="!canSave()" (click)="onSave()">Save</button>
            <button *ngIf="canDelete()" type="button" class="btn btn-sm btn-primary" (click)="onDelete()">Confirm Constituent Removal</button>
            <button *ngIf="!_parentData.deleting && (_parentData.adding || _parentData.editing)" type="button" class="btn btn-sm btn-primary" [disabled]="!canApply()" (click)="onApply()">Apply</button>
            <button *ngIf="canShowBack()" type="button" class="btn btn-sm btn-primary" (click)="onBack()">Back</button>
            <button *ngIf="canCancel()" type="button" class="btn btn-sm btn-primary" (click)="onCancel()">Cancel</button>
        </span>
    </editor-header>
</div>

<div *ngIf="!_parentData.deleting && (this._parentData.editing || this._parentData.adding)">
    <p class="bold" style="color: #a94442;">{{_materialValidationMessage}}</p>

    <div class="form-group row">
        <button *ngIf="_parentData.adding" type="button" class="col-md-2 btn btn-sm btn-primary" style="margin-left: 16px; width: 180px;" (click)="onSelectComponentMaterial()">Select Constituent Material</button>
        <div *ngIf="_edm.currentEntity.materialComponent" class="col-md-4">
            <span class="inline bold">Constituent Material Identifiers:</span>
            <default-table>
                <thead>
                <tr>
                    <td>CAS No.</td>
                    <td>RIFM ID</td>
                    <td>Principal Synonym</td>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>{{_edm.currentEntity.materialComponent.material.realCASNumber}}</td>
                    <td>{{_edm.currentEntity.materialComponent.material.formattedRIFMId}}</td>
                    <td [htmlGreek]="_edm.currentEntity.materialComponent.material.principalSynonymText()"></td>
                </tr>
                </tbody>
            </default-table>
        </div>
    </div>

    <div class="form-group row">
        <edit-prop label="Constituent Percentage" prop="componentAmount" szs="2,2">
            <input class="form-control" type="text" [(ngModel)]="_edm.currentEntity.componentAmount">
        </edit-prop>
        <span class="bold" style="color: #a94442;">{{_componentAmountValidationMessage}}</span>
    </div>

    <div class="form-group row">
        <edit-prop label="Validation Date" prop="validationDate" szs="2,2">
            <input class="form-control" type="text" (change)="onValidationDateChange()" [(ngModel)]="pickValidationDate">
        </edit-prop>
        <span class="bold" style="color: #a94442;">{{_dateValidationMessage}}</span>
    </div>

    <div class="form-group  row">
        <edit-prop label="Item Code" prop="itemCode" szs="2,2">
            <textarea class="form-control" rows=1 [(ngModel)]="_edm.currentEntity.itemCode"></textarea>
        </edit-prop>
    </div>

</div>

<material-selector></material-selector>
